<template>
  <div>
    <WyneLoverTopNav active-app="cellar" />
    <MatchMedia query="(max-width: 768px)" v-slot="{ matches }">
      <LoginMobile v-if="matches" />
      <LoginDesktop v-else />
    </MatchMedia>
  </div>
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'
import Cookies from 'js-cookie'
import WyneLoverTopNav from '@/components/WyneLover_TopNav.vue'
import LoginMobile from '@/components/Login_Mobile.vue'
import LoginDesktop from '@/components/Login_Desktop.vue'

export default {
  name: 'Login',
  components: { MatchMedia, WyneLoverTopNav, LoginMobile, LoginDesktop },
  created() {
    const supported = ['en', 'fr', 'de', 'es', 'it', 'nl', 'pt']
    let language = Cookies.get('wynelover.language')
    if (!supported.includes(language)) language = 'en'
    this.$store.commit('setLanguage', language)
  }
}
</script>
